import React from 'react';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';

import * as ds from './dataService';
import {
  Stack,
  Typography
} from '@mui/material';
import { DateTime } from 'luxon';
import _ from 'lodash';
import { useParams } from 'react-router-dom';

export type SaveMilestoneFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: SaveMilestoneFormProps) => {
  const [
    fnSaveForm,
    { loading }
  ] = ds.useSaveMilestoneForm();
  const params = useParams();
  const form = ds.useFormState(props.id, params.projectId ?? '');
  const handleSubmit = async (data: ds.IFormState) => {
    await fnSaveForm({
      ...data,
      durationInDays: _.toNumber(data.durationInDays),
      endDate: DateTime.fromFormat(data.endDate, 'yyyy-LL-dd'),
      startDate: DateTime.fromFormat(data.startDate, 'yyyy-LL-dd')
    });
    props.handleClose();
  };

  const handleUpdateDurationForEndDate = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, fieldName: keyof ds.IFormState) => {
    let startDate: DateTime;
    let endDate: DateTime;

    if (fieldName === 'endDate') {
      startDate = DateTime.fromFormat(form.formState.startDate, 'yyyy-LL-dd');
      endDate = DateTime.fromFormat(e.target.value, 'yyyy-LL-dd');
    } else {
      startDate = DateTime.fromFormat(e.target.value, 'yyyy-LL-dd');
      endDate = DateTime.fromFormat(form.formState.endDate, 'yyyy-LL-dd');
    }
    const duration = endDate.diff(startDate).shiftTo('days').days.toFixed(0);

    form.dispatch({
      type: 'UPDATE',
      payload: {
        property: 'durationInDays',
        value: duration
      }
    });
    if (fieldName === 'endDate') {
      form.dispatch({
        type: 'UPDATE',
        payload: {
          property: 'endDate',
          value: e.target.value
        }
      });
    } else {
      form.dispatch({
        type: 'UPDATE',
        payload: {
          property: 'startDate',
          value: e.target.value
        }
      });
    }
  };



  const handleUpdateEndDateForDuration = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const startDate = DateTime.fromFormat(form.formState.startDate, 'yyyy-LL-dd');
    const duration = _.toNumber(e.target.value);
    const endDate = startDate.plus({
      days: duration
    }).toFormat('yyyy-LL-dd');

    form.dispatch({
      type: 'UPDATE',
      payload: {
        property: 'durationInDays',
        value: `${duration}`
      }
    });
    form.dispatch({
      type: 'UPDATE',
      payload: {
        property: 'endDate',
        value: endDate
      }
    });
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <Stack
        rowGap='1.5rem'
        width='28rem'
      >
        <StyledTextField.FC
          {...form.genFieldProps('title')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('description')}
        />

        <StyledTextField.FC
          {...form.genFieldProps('startDate')}
          onChange={(e) => {
            handleUpdateDurationForEndDate(e, 'startDate');
          }}
        />

        <Typography
          variant='modalSubTitle'
        >
          Select the length of your milestone by typing in number of days or by picking ending date.
        </Typography>
        <StyledTextField.FC
          {...form.genFieldProps('durationInDays')}
          onChange={(e) => {
            handleUpdateEndDateForDuration(e);
          }}
        />
        <StyledTextField.FC
          {...form.genFieldProps('endDate')}
          onChange={(e) => {
            handleUpdateDurationForEndDate(e, 'endDate');
          }}
        />
      </Stack>
    </FormBaseLayout.FC>

  );
};
